import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import Loading from '../../components/loading'
import { getVideo } from '../../../common/contentful'
import VideoPlayer from '../../components/video-player'

class Watch extends Component {
	constructor(props) {
		super(props)

		const {
			params
		} = this.props.match

		this.videoId = params.id

		this.state = {
			title: null
		}
	}

	componentDidMount() {
		this.mounted = true;

		if (this.state.title === null) {
			getVideo(this.videoId, (entry) => {
				if (this.mounted) {
					this.setState({
						title: entry[0],
					})
				}
			})
		}
	}

	componentWillUnmount() {
		this.mounted = false;
	}

	render() {
		let rendered = null

		rendered = <Loading />

		if (this.state.title !== null) {
			const {
				title,
			} = this.state

			rendered = <VideoPlayer id={title.youTubeId} />
		}

		return rendered
	}
}

export default withRouter(Watch)



// WEBPACK FOOTER //
// ./src/desktop/pages/watch/index.js